// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"hospital-1"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M5 21V9.25L12 3L19 9.22222V21H5Z"}},{"tag":"path","attrs":{"id":"fill2","fill":"props.fillColor2","d":"M10.0003 16V21H14.0003V16H10.0003Z"}},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M10 10H12M12 10H14M12 10V8M12 10V12M10.0003 21V16H14.0003V21H10.0003Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M5 9.77653V21H19V9.75M3 11L12 3L21 11","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const Hospital1Icon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'hospital-1',
    ref,
    icon: element,
  },
));

Hospital1Icon.displayName = 'Hospital1Icon';

export default Hospital1Icon;
